module.exports = __webpack_public_path__ + "static/media/Madfit-2.e7821210.jpg";